import { ISmartercodesState } from '../smartercodes.reducers';
import { IContext } from 'Dashboard/redux/dashboard.reducer';

export default function apiDataOverview(
    state: ISmartercodesState,
    rawApiData: any,
    context: IContext,
    extraParams: any
) {
    let newState = { ...state };
    // format `overview` data however needed here!
    return newState;
}
